import React from 'react';
import PointsUI from 'src/components/ui/pointsUI';
import PointsInputs from 'src/components/ui/pointsUI/PointsInputs';
import TimeWidget from './TimeWidget';
import TimeWidgetIntegerList from './TimeWidgetIntegerList';
import { Widgets } from '../../../modules/points/types/widgetTypes';
import { WidgetsTemplate } from '../../../modules/points/types/pointsWidgetstypes';
import { PointsProps } from '../../../modules/points/types/types';
import { EQUIPMENT_MAKE } from '../../../modules/points/types/types';
import { getPointId } from '../../../modules/points/helpers';
interface WidgetRendererProps {
  widget: WidgetsTemplate;
  inputValues: Record<string, string | number | string[]>;
  onChange: (point: PointsProps, value: string | number | string[]) => void;
}

const WidgetRenderer: React.FC<WidgetRendererProps> = ({ widget, inputValues, onChange }) => {
  if (widget.widget === Widgets.dateTime) {
    if (widget.make === EQUIPMENT_MAKE.avalon) {
      return (
        <TimeWidget
          inputValues={inputValues}
          points={widget.points}
          onChange={onChange}
          title={widget.widgetLabel}
        />
      );
    } else if (widget.make === EQUIPMENT_MAKE.envy) {
      return (
        <TimeWidgetIntegerList
          inputValues={inputValues}
          points={widget.points}
          onChange={onChange}
          title={widget.widgetLabel}
        />
      );
    }
  }

  return (
    <>
      {widget.points.map((point, index) => (
        <PointsUI
          key={getPointId(point)}
          title={point.entry.name}
          description={point.entry.description}
          unit={point.unit}
          readOnly={point.readOnly}
        >
          <PointsInputs
            dataType={point.entry.dType}
            inputProps={{
              point,
              options: point.entry.meanings ? Object.keys(point.entry.meanings) : [],
              value: inputValues[getPointId(point)],
              onChange: onChange,
            }}
          />
        </PointsUI>
      ))}
    </>
  );
};

export default WidgetRenderer;
